"use strict";

const Series = () => {
    const init = () => {
        window.onClickSeriesTab = function($this){
            let $parent = $this.parents('.js-series');
            $parent.find('.js-series-tab').removeClass('active');
            $parent.find('.js-series-element').removeClass('active');
            $this.addClass('active');
            $parent.find('.js-series-element[data-id="'+$this.data('id')+'"]').addClass('active');
        }
    };

    return {
        init:init
    };
};

export default Series;